import { render } from "./CompaniesList.vue?vue&type=template&id=9f7c001e"
import script from "./CompaniesList.vue?vue&type=script&lang=js"
export * from "./CompaniesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__